export default __webpack_public_path__ + "static/media/image-activity-card-transparent-background.e28da231.svg";